import { QueryCache, QueryClient } from "@tanstack/react-query";
import { millisecondsInMinute } from "date-fns/constants";
import { captureError } from "@utils/analytics.ts";
import { notifyNetworkError } from "@utils/notification.ts";

const isResponse = (res: any): res is Response => res instanceof Response;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // (also relates to the `refetchOnWindowFocus` setting which is `true` by default)
      staleTime: millisecondsInMinute * 30,
      retry: 0,
      gcTime: 300_000,
    },
  },

  // https://stackoverflow.com/a/75917353/104380
  // https://tkdodo.eu/blog/react-query-error-handling#the-global-callbacks
  queryCache: new QueryCache({
    onError: (error) => {
      captureError("React Query global error handler", error);
      if (isResponse(error)) {
        notifyNetworkError(error);
      }
    },
  }),
});
